"use strict";

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Grid, Checkbox, Input, Modal, Panel } from 'framework-ui-components';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import { datiRiduzioneAcconto, stampaRiduzioneAcconto } from 'apis/setteTrentaApi';

function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

function saveByteArray(reportName, byte) {
  var blob = new Blob([byte]);
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  var fileName = reportName + ".pdf";
  link.download = fileName;
  link.click();
};

class ModaleRiduzioneAcc extends Component {

  state = {
    idDichiarazione: this.props.idDichiarazione,
    annullareIrpef: false,
    ridurreIrpef: false,
    importoIrpef: null,
    annullareCedolare: false,
    ridurreCedolare: false,
    importoCedolare: null,
    annullareIrpefConiuge: false,
    ridurreIrpefConiuge: false,
    importoIrpefConiuge: null,
    annullareCedolareConiuge: false,
    ridurreCedolareConiuge: false,
    importoCedolareConiuge: null,
    descrizioneSostituto: "",
    senzaSostituto: false,
    dichiarante: "",
    secondoAccontoIRPEF: 0,
    secondoAccontoCedolareSecca: 0,
    coniuge: "",
    secondoAccontoIRPEFConiuge: 0,
    secondoAccontoCedolareSeccaConiuge: 0,
    abilitaStampa: false,
    loadModal: true
  }

  componentDidMount() {
    datiRiduzioneAcconto(this.props.idDichiarazione, this.props.annoSelezionato)
      .then(res => {
        if (res != null) {
          this.setState({
            loadModal: false,
            descrizioneSostituto: res.DescrizioneSostituto,
            senzaSostituto: res.SenzaSostituto,
            dichiarante: res.DescrizioneDichiarante,
            secondoAccontoIRPEF: res.SecondoAccontoIRPEF,
            secondoAccontoCedolareSecca: res.SecondoAccontoCedolareSecca,
            coniuge: res.DescrizioneConiuge,
            secondoAccontoIRPEFConiuge: res.SecondoAccontoIRPEFConiuge,
            secondoAccontoCedolareSeccaConiuge: res.SecondoAccontoCedolareSeccaConiuge
          });
        } else {
          SnackbarManager.notifyError("Errore lettura dati dichiarazione");
          this.props.onClose();
        }
      });
  }

  stampa = () => {
    // correggi valori nulli o errati    
    let args = Object.assign({}, this.state);
    if (!args.importoIrpef) { args.importoIrpef = 0; }
    if (!args.importoCedolare) { args.importoCedolare = 0; }
    if (!args.importoIrpefConiuge) { args.importoIrpefConiuge = 0; }
    if (!args.importoCedolareConiuge) { args.importoCedolareConiuge = 0; }

    let cfDichiarante = "";
    try {
      cfDichiarante = args.dichiarante.match(/\(([^)]+)\)/)[1];
    } catch (e) { }

    if (this.form.valida()) {
      args.Anno = this.props.annoSelezionato;
      stampaRiduzioneAcconto(args, this.props.annoSelezionato)
        .then((a) => this.showFile(a, cfDichiarante))
        .then(() => {
          this.setState({ loadModal: false });
          this.props.onClose();
        });
      this.setState({ loadModal: true });
    }
  }

  showFile = (res, cfDichiarante) => {
    let sampleArr = base64ToArrayBuffer(res);
    saveByteArray("ridAcc" + cfDichiarante, sampleArr);
  }

  handleChange = data => {
    if (data.annullareIrpef) {
      data.ridurreIrpef = false;
      data.importoIrpef = null;
    }
    if (data.ridurreIrpef) {
      data.annullareIrpef = false;
    }

    if (data.annullareCedolare) {
      data.ridurreCedolare = false;
      data.importoCedolare = null;
    }
    if (data.ridurreCedolare) {
      data.annullareCedolare = false;
    }

    if (data.annullareIrpefConiuge) {
      data.ridurreIrpefConiuge = false;
      data.importoIrpefConiuge = null;
    }
    if (data.ridurreIrpefConiuge) {
      data.annullareIrpefConiuge = false;
    }

    if (data.annullareCedolareConiuge) {
      data.ridurreCedolareConiuge = false;
      data.importoCedolareConiuge = null;
    }
    if (data.ridurreCedolareConiuge) {
      data.annullareCedolareConiuge = false;
    }

    this.setState(data);
  }

  validaImportoIrpef() {
    return [
      (x, y) => { if (this.state.ridurreIrpef && !(x > 0)) { return "Se acconto vale 0, allora selezionare \"Annullamento secondo acconto IRPEF\""; } else { return null; } },
      (x, y) => { if (this.state.ridurreIrpef && (this.state.importoIrpef >= this.state.secondoAccontoIRPEF)) { return "Valore maggiore o uguale all'importo del secondo/unico acconto IRPEF"; } else { return null; } }
    ];
  }

  validaImportoIrpefConiuge() {
    return [
      (x, y) => { if (this.state.ridurreIrpefConiuge && !(x > 0)) { return "Se acconto vale 0, allora selezionare \"Annullamento secondo acconto IRPEF\""; } else { return null; } },
      (x, y) => { if (this.state.ridurreIrpefConiuge && (x >= this.state.secondoAccontoIRPEFConiuge)) { return "Valore maggiore o uguale all'importo del secondo/unico acconto IRPEF"; } else { return null; } }
    ];
  }

  validaImportoCedolare() {
    return [
      (x, y) => { if (this.state.ridurreCedolare && !(x > 0)) { return "Se acconto vale 0, allora selezionare \"Annullamento secondo acconto IRPEF\""; } else { return null; } },
      (x, y) => { if (this.state.ridurreCedolare && (x >= this.state.secondoAccontoCedolareSecca)) { return "Valore maggiore o uguale all'importo del secondo/unico acconto IRPEF"; } else { return null; } }
    ];
  }

  validaImportoCedolareConiuge() {
    return [
      (x, y) => { if (this.state.ridurreCedolareConiuge && !(x > 0)) { return "Se acconto vale 0, allora selezionare \"Annullamento secondo acconto IRPEF\""; } else { return null; } },
      (x, y) => { if (this.state.ridurreCedolareConiuge && (x >= this.state.secondoAccontoCedolareSeccaConiuge)) { return "Valore maggiore o uguale all'importo del secondo/unico acconto IRPEF"; } else { return null; } }
    ];
  }

  validaForm = e => {
    this.form.valida();
  }

  render() {
    const { showModal, onClose, isLoading } = this.props;
    const {
      loadModal,
      descrizioneSostituto,
      senzaSostituto,

      dichiarante,
      secondoAccontoIRPEF,
      annullareIrpef,
      ridurreIrpef,
      importoIrpef,
      secondoAccontoCedolareSecca,
      annullareCedolare,
      ridurreCedolare,
      importoCedolare,
      coniuge,
      secondoAccontoIRPEFConiuge,
      annullareIrpefConiuge,
      ridurreIrpefConiuge,
      importoIrpefConiuge,
      secondoAccontoCedolareSeccaConiuge,
      annullareCedolareConiuge,
      ridurreCedolareConiuge,
      importoCedolareConiuge,

    } = this.state;


    const abilitaStampa = (ridurreIrpef || annullareIrpef || annullareCedolare || ridurreCedolare || annullareIrpefConiuge || ridurreIrpefConiuge || annullareCedolareConiuge || ridurreCedolareConiuge)

    var mbody = null;
    var mfooter = null;
    if (senzaSostituto) {

      mbody = (
        <Modal.Body>
          <Panel title='Errore' error>
            Non e' possibile generare la lettera di annullamento/riduzione secondo acconto in quanto la dichiarazione e' senza sostituto d'imposta: e' sufficiente modificare l'importo dell'acconto nell'F24 oppure non versarlo
                </Panel>
        </Modal.Body>
      );
      mfooter = (
        <Modal.Footer>
          <Button flat onClick={this.props.onClose}>Chiudi</Button>
        </Modal.Footer>
      );

    } else if (secondoAccontoIRPEF == 0 && secondoAccontoCedolareSecca == 0
      && secondoAccontoIRPEFConiuge == 0 && secondoAccontoCedolareSeccaConiuge == 0) {

      mbody = (
        <Modal.Body>
          <Panel title='Errore' error>
            Non e' possibile generare la lettera di annullamento/riduzione secondo acconto in quanto la dichiarazione non presenta nessun secondo acconto IRPEF o cedolare secca
                    </Panel>
        </Modal.Body>
      );
      mfooter = (
        <Modal.Footer>
          <Button flat onClick={this.props.onClose}>Chiudi</Button>
        </Modal.Footer>
      );

    } else {

      mbody = (
        <Modal.Body>
          <Form stato={this.state} onChange={this.handleChange} ref={r => this.form = r}>
            <p style={{ color: '#ccc' }}>Sostituto d'imposta: <strong>{descrizioneSostituto}</strong></p>
            {(secondoAccontoIRPEF > 0 || secondoAccontoCedolareSecca > 0) && <div>
              <hr style={{ color: '#ccc' }} />
              <p style={{ color: '#ccc' }}>Dichiarante: <strong>{dichiarante}</strong></p>
            </div>
            }

            {secondoAccontoIRPEF > 0
              && (
                <Grid fluid>
                  <Grid.Row>
                    <Grid.Col sm="12">
                      <label><strong>Secondo acconto IRPEF</strong></label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Col sm="12">
                      <label>Il dichiarante intende comunicare al sostituto d'imposta di:</label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Col sm="12">
                      <label>
                        <Checkbox name="annullareIrpef" onClick={this.validaForm} />
                        Annullare il secondo acconto IRPEF di &euro; {secondoAccontoIRPEF}
                      </label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Col sm="7">
                      <label style={{ "marginTop": "5px" }}>
                        <Checkbox name="ridurreIrpef" onClick={this.validaForm} />
                        Ridurre il secondo acconto IRPEF di &euro; {secondoAccontoIRPEF} a &euro;
                                            </label>
                    </Grid.Col>
                    <Grid.Col sm="2">
                      <Input format="number" validations={this.validaImportoIrpef()} disabled={!ridurreIrpef} name="importoIrpef" className="inlineInput" />
                    </Grid.Col>
                  </Grid.Row>
                </Grid>
              )}
            {secondoAccontoCedolareSecca > 0
              && (
                <Grid fluid>
                  <Grid.Row>
                    <Grid.Col sm="12">
                      <label><strong>Secondo acconto cedolare secca</strong></label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Col sm="12">
                      <label>Il dichiarante intende comunicare al sostituto d'imposta di:</label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Col sm="12">
                      <label>
                        <Checkbox name="annullareCedolare" onClick={this.validaForm} />
                        Annullare il secondo acconto cedolare secca di &euro; {secondoAccontoCedolareSecca}
                      </label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Col sm="7">
                      <label style={{ "marginTop": "5px" }}>
                        <Checkbox name="ridurreCedolare" onClick={this.validaForm} />
                        Ridurre il secondo acconto cedolare secca di &euro; {secondoAccontoCedolareSecca} a &euro;
                                            </label>
                    </Grid.Col>
                    <Grid.Col sm="2">
                      <Input format="number" validations={this.validaImportoCedolare()} disabled={!ridurreCedolare} className="inlineInput" name="importoCedolare" />
                    </Grid.Col>
                  </Grid.Row>
                </Grid>
              )}
            {coniuge && (secondoAccontoIRPEFConiuge > 0 || secondoAccontoCedolareSeccaConiuge > 0) && <div>
              <hr style={{ color: '#ccc' }} />
              <p style={{ color: '#ccc' }}>Coniuge: <strong>{coniuge}</strong></p>
            </div>
            }
            {coniuge && secondoAccontoIRPEFConiuge > 0 &&
              <Grid fluid>
                <Grid.Row>
                  <Grid.Col sm="12">
                    <label><strong>Secondo acconto IRPEF</strong></label>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col sm="12">
                    <label>Il dichiarante intende comunicare al sostituto d'imposta di:</label>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col sm="12">
                    <label>
                      <Checkbox name="annullareIrpefConiuge" onClick={this.validaForm} />
                      Annullare il secondo acconto IRPEF di &euro; {secondoAccontoIRPEFConiuge}
                    </label>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col sm="7">
                    <label style={{ "marginTop": "5px" }}>
                      <Checkbox name="ridurreIrpefConiuge" onClick={this.validaForm} />
                      Ridurre il secondo acconto IRPEF di &euro; {secondoAccontoIRPEFConiuge} a &euro;
                                            </label>
                  </Grid.Col>
                  <Grid.Col sm="2">
                    <Input format="number" validations={this.validaImportoIrpefConiuge()} disabled={!ridurreIrpefConiuge} className="inlineInput" name="importoIrpefConiuge" />
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            }
            {coniuge && secondoAccontoCedolareSeccaConiuge > 0 &&
              <Grid fluid>
                <Grid.Row>
                  <Grid.Col sm="12">
                    <label><strong>Secondo acconto cedolare secca</strong></label>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col sm="12">
                    <label>Il dichiarante intende comunicare al sostituto d'imposta di:</label>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col sm="12">
                    <label>
                      <Checkbox name="annullareCedolareConiuge" onClick={this.validaForm} />
                      Annullare il secondo acconto cedolare secca di &euro; {secondoAccontoCedolareSeccaConiuge}
                    </label>
                  </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Col sm="7">
                    <label style={{ "marginTop": "5px" }}>
                      <Checkbox name="ridurreCedolareConiuge" onClick={this.validaForm} />
                      Ridurre il secondo acconto cedolare secca di &euro; {secondoAccontoCedolareSeccaConiuge} a &euro;
                                            </label>
                  </Grid.Col>
                  <Grid.Col sm="2">
                    <Input format="number" validations={this.validaImportoCedolareConiuge()} disabled={!ridurreCedolareConiuge} className="inlineInput" name="importoCedolareConiuge" />
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            }
          </Form>
        </Modal.Body>
      );
      mfooter = (
        <Modal.Footer>
          <Button flat onClick={this.props.onClose}>Annulla</Button>
          <Button flat primary onClick={this.stampa} disabled={!abilitaStampa} >Salva e stampa</Button>
        </Modal.Footer>
      );
    }

    return (
      <Modal show={showModal} onClose={onClose} loading={loadModal} >
        <Modal.Header>Lettera riduzione/annullamento secondo acconto</Modal.Header>
        {mbody}
        {mfooter}
      </ Modal >
    );
  }
}
//ModaleRiduzioneAcc.propTypes = {
//    datiIniziali: PropTypes.object,
//    isLoading: PropTypes.bool,
//    messaggioErrore: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
//    messaggioErrore: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
//    onAnnulla: PropTypes.func.isRequired,
//    onCreaNuova: PropTypes.func,
//    onRipristinaEliminata: PropTypes.func,
//    showModal: PropTypes.bool.isRequired,
//    tipoDichiarazione: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
//    ufficioSelezionato: PropTypes.string
//};

export default ModaleRiduzioneAcc;